import {
    message,
    Divider,
    Radio,
    Tooltip,
    Upload,
    Tabs,
    Button,
    Modal,
    Form,
    Input,
    Row,
    Col,
    Typography,
    Spin,
} from 'antd';
import FeatherIcon from 'feather-icons-react';
import React, { useState, useEffect } from 'react';
import PartStore from '@partsbadger/one-true-form/lib/stores/PartStore';
import QuoteStore from '@partsbadger/one-true-form/lib/stores/QuoteStore';
import ITARNotice from '@partsbadger/one-true-form/lib/components/ITARNotice';
import { RcFile, UploadProps } from 'antd/es/upload';
//Copied from zip.js
import { allowed_2d, allowed_3d, getMimeType, useQueryParameters } from '@partsbadger/utils';
import * as api from '@partsbadger/utils';
import UserStore from 'stores/UserStore';
import { Redirect, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { LoadingOutlined } from '@ant-design/icons';
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';
import { GAEvent } from '../../utils/tracking';
import { isFreeEmailDomain } from '../../utils/utils';

const LIMIT_LINE_ITEMS = 100;

export const UploadPartFilePublic = observer(() => {
    const history = useHistory();
    const searchParams = useQueryParameters();

    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [uploadInitiated, setUploadInitiated] = useState<boolean>(false);
    const [emailDomains, setEmailDomains] = useState<string[]>([]);

    const [modalForm, setModalForm] = useState<string>('email');

    const [loginForm] = Form.useForm();

    useEffect(() => {
        UserStore.getEmailDomains()
            .then(res => {
                const domainList = res.results?.map((item: { id: number; domain: string }) =>
                    item?.domain?.toLowerCase()
                );
                setEmailDomains(domainList);
            })
            .catch(err => {
                console.error('Error fetching email domains:', err);
            });
    }, []);

    // interface FileProps {
    //     index: number;
    //     uid: string;
    //     name: string;
    //     file: File;
    //     '3D File': {
    //         uid: string;
    //     };
    //     '2D File': {
    //         uid: string;
    //     };
    //     'Additional File': Array<AdditionalFile>;
    //     type: '3D File' | '2D File' | 'Additional File';
    //     similarity: number;
    //     uploading: boolean;
    //     progress: number;
    // }

    const uploading =
        PartStore?.fileParts.length > 0 &&
        !!PartStore?.fileParts?.find((filePart: any) => filePart?.uploading === true && filePart?.progress !== 100);

    const handleSubmit = async (user_info: Record<string, unknown>) => {
        setLoading(true);

        try {
            const getParam = (param: string) => searchParams.get(param) || null;

            const utmParams = JSON.parse(localStorage.getItem('utm_params') || '{}');

            const utm_campaign = utmParams.utm_campaign;
            const utm_medium = utmParams.utm_medium;
            const utm_source = utmParams.utm_source;
            const first_source = utmParams.first_source;

            const li_fat_id = getParam('li_fat_id');
            const gclid = utmParams.gclid || getParam('gclid');
            const fbclid = getParam('fbclid');

            const payload = {
                ...user_info,
                utm_campaign,
                utm_medium,
                utm_source,
                first_source,
                li_fat_id,
                gclid,
                fbclid,
                campaign_tracking: utmParams,
            };

            GAEvent('Form', 'Rapid Quote Started');

            const data = await api.requests.post(`/customer/quote/start/`, payload);

            window.localStorage.setItem('quote_token', data.quote_token);

            QuoteStore.setSignedUID(data.quote_token);
            QuoteStore.setQuote(data.quote);

            setUploadInitiated(true);

            PartStore.fileParts.map((filePart: any) => {
                if (filePart['3D File']?.uid || filePart['2D File']?.uid || filePart['Additional File']?.length) {
                    PartStore.uploadPart(filePart);
                }
            });
        } catch (error) {
            message.error('Error, please try again');
            window.localStorage.removeItem('quote_token');
        }

        setModalVisible(false);
        setLoading(false);
    };

    const submitLogin = async (values: any) => {
        setLoading(true);

        try {
            await UserStore.login(values.email, values.password1);

            const quote = await api.get(
                `/customer/quote/last?email=${encodeURIComponent(values.email)}`
            );

            QuoteStore.setQuote(quote);
        } catch (e) {
            console.log(e);
        }

        setLoading(false);
    };

    const uploadProps: UploadProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        // disabled: PartStore.fileParts.length > 0,
        beforeUpload: (file: RcFile) => {
            const isLt2M = file.size / 1024 / 1024 < 100;

            if (!isLt2M) {
                message.error('File must smaller than 100MB!', 10);
                return false;
            }

            if (PartStore.hasParts()) {
                PartStore.fileParts.map((filePart: any) => PartStore.removePart(filePart));
            }

            PartStore.addPart(file);

            setModalVisible(true);

            return false;
        },
    };

    useEffect(() => {
        if (QuoteStore.quote?.uid && UserStore.isAuthenticated) {
            PartStore.fileParts.map((filePart: any) => {
                if (filePart['3D File']?.uid || filePart['2D File']?.uid || filePart['Additional File']?.length) {
                    PartStore.uploadPart(filePart);
                }
            });

            setLoading(false);
            setModalVisible(false);
            history.push(`/my-account/quotes/new-quote/?${searchParams.toString()}`);
        }
    }, [QuoteStore.quote]);

    useEffect(() => {
        if (PartStore.fileParts.find((filePart: any) => filePart?.uploading === true && filePart?.progress === 100)) {
            history.push('/rapid-quote');
        }
    }, [PartStore.fileParts]);

    if (UserStore.isAuthenticated) {
        history.push(`/my-account/quotes/new-quote/?${searchParams.toString()}`);
    }

    const handleCancel = () => {
        setModalVisible(false);
        setModalForm('email');
    };

    return (
        <>
            <Modal
                width={'auto'}
                style={{ minWidth: 320, maxWidth: 480 }}
                open={modalVisible}
                closable={true}
                footer={null}
                onCancel={handleCancel}
            >
                {modalForm === 'email' ? (
                    <Form
                        form={loginForm}
                        layout={'vertical'}
                        requiredMark={false}
                        onFinish={data => handleSubmit(data)}
                    >
                        <h2>Please enter your info to continue</h2>
                        <Row gutter={[8, 8]}>
                            <Col span={12}>
                                <Form.Item
                                    name={'first_name'}
                                    label={'First Name'}
                                    className={'m-0'}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Field is required',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name={'last_name'}
                                    label={'Last Name'}
                                    className={'m-0'}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Field is required',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item
                            name={'email'}
                            label={'Email'}
                            className={'m-0'}
                            rules={[
                                {
                                    required: true,
                                    message: 'Email is required',
                                },
                                {
                                    type: 'email',
                                    message: 'Please input a valid email',
                                },
                            ]}
                        >
                            <Input
                                type={'email'}
                                onChange={() => {
                                    if (loginForm.isFieldTouched('company')) {
                                        loginForm.validateFields(['company']);
                                    }
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, curValues) => prevValues.email !== curValues.email}
                        >
                            {({ getFieldValue }) => (
                                <Form.Item
                                    name={'company'}
                                    label={
                                        isFreeEmailDomain(getFieldValue('email'), emailDomains)
                                            ? 'Company (Optional)'
                                            : 'Company'
                                    }
                                    className={'m-0'}
                                    rules={[
                                        {
                                            required: !isFreeEmailDomain(getFieldValue('email'), emailDomains),
                                            message: 'Company is required',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            )}
                        </Form.Item>

                        <Form.Item className="mb-0">
                            <Button
                                id="continue-to-rfq"
                                type="primary"
                                htmlType="submit"
                                className="mt-3 mb-0"
                                block={true}
                                loading={loading}
                                size="large"
                            >
                                Continue to Quote
                            </Button>
                        </Form.Item>
                        <p className="text-center mb-0">
                            Already have an account?{' '}
                            <Button
                                type="link"
                                className="m-0 p-0"
                                onClick={() => setModalForm('login')}
                                loading={loading}
                            >
                                Login
                            </Button>
                        </p>
                    </Form>
                ) : modalForm === 'login' ? (
                    <Form form={loginForm} onFinish={submitLogin} layout={'vertical'} requiredMark={false}>
                        <Typography.Title>Login</Typography.Title>
                        <Form.Item
                            name="email"
                            label={'Email'}
                            hasFeedback
                            validateTrigger="onBlur"
                            rules={[
                                {
                                    type: 'email',
                                    required: true,
                                    message: 'Please insert a valid email',
                                },
                            ]}
                        >
                            <Input autoComplete={'username'} />
                        </Form.Item>

                        <Form.Item
                            name={'password1'}
                            label={'Password'}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Password is required',
                                },
                                {
                                    min: 1,
                                    message: 'Password must have at least 8 characters',
                                },
                            ]}
                        >
                            <Input.Password type={'password'} autoComplete={'current-password'} />
                        </Form.Item>

                        <Button
                            type="primary"
                            block={true}
                            loading={loading}
                            htmlType="submit"
                            size="large"
                            className="mb-2"
                        >
                            Login
                        </Button>

                        <Button type="default" block onClick={() => setModalForm('email')}>
                            Go Back
                        </Button>
                    </Form>
                ) : null}
            </Modal>

            {uploadInitiated && QuoteStore?.quote?.uid && QuoteStore?.quote?.line_items?.length > 0 ? (
                <RedirectPreservingUTMQuery to="/rapid-quote" />
            ) : (
                <>
                    <ITARNotice />
                    <div className="mb-2">
                        <div className="d-flex align-items-center text-muted">
                            <div className="d-flex align-items-center">
                                <FeatherIcon icon="lock" size={14} className="mr-1" />
                                <span>File uploads are secure and confidential</span>
                            </div>
                            <div className="d-flex align-items-center ml-auto">
                                <FeatherIcon icon="award" size={14} className="mr-1" />
                                <span>ISO 9001:2015 and AS 9100 Certified</span>
                            </div>
                        </div>
                        <Spin indicator={<LoadingOutlined />} spinning={loading}>
                            <Upload.Dragger
                                {...uploadProps}
                                className="mt-1 py-2 w-100"
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <>
                                    <p
                                        className="ant-upload-text pb-2"
                                        style={{ fontSize: '1.35rem', fontWeight: 900 }}
                                    >
                                        Upload your part file to start your rapid quote
                                    </p>

                                    <p className="ant-upload-hint w-full m-auto">
                                        <span>Drag and drop your 2D or 3D file.</span>
                                    </p>

                                    <div style={{ width: '6rem', margin: '0 auto' }}>
                                        <Divider>or</Divider>
                                    </div>

                                    <Button
                                        type="primary"
                                        // size="large"
                                        className="d-flex align-items-center mx-auto mb-2 shadow-light"
                                        icon={<FeatherIcon icon="upload-cloud" size="22" className="mr-2" />}
                                    >
                                        Upload File
                                    </Button>

                                    <p className="pt-3">
                                        <span className="text-uppercase">
                                            {allowed_3d.replace(/,/g, ',  ')}
                                            {',  '}
                                            {allowed_2d.replace(/,/g, ',  ')}
                                        </span>
                                    </p>

                                    <p>100 MB Max File Size</p>
                                </>
                                {/* </Tooltip> */}
                            </Upload.Dragger>
                        </Spin>
                    </div>
                </>
            )}
        </>
    );
});
